import { Dialog, Notify, Toast } from 'vant';
import { createId, getGbStringLength } from '@/utils/index'

//初始化弹窗参数
function initDialogOpt(title, msg) {
    let opt = {
        title: title,
        message: msg
    };
    title = title || "出错了";
    if (!msg) {
        if (typeof (title) == "object") {
            if (!title.message && title.msg) {
                title.message = title.msg;
            }
            opt = title.message ? title : { message: title };
        } else {
            opt = {
                message: title
            };
        }
    }
    if (getGbStringLength(opt.message) > 38) {
        opt.messageAlign = "left";
    }
    return opt;
}

export function showMsg(title, msg) {
    let opt = initDialogOpt(title, msg);
    return Dialog.alert(opt);
};
export function confirm(title, msg) {
    let opt = initDialogOpt(title, msg);
    return Dialog.confirm(opt)
};
export function msg(opt) {
    if (opt && opt instanceof Error) {
        return Toast.fail({ message: opt.message || opt.msg || "出错了" })
    }
    if (opt === "cancel") {
        return false;
    }
    return Toast(opt)
};
msg.fail = msg.error = msg => {
    if (msg === "cancel") {
        return false;
    }
    if (msg && msg instanceof Error) {
        return Toast.fail({ message: msg.message || msg.msg || "出错了" })
    }
    return Toast.fail(msg)
};
msg.success = msg => {
    return Toast.success(msg)
};
export const message = msg;
message.errorFun = message.error || msg.error;
message.fail = message.error = opt => {
    if (opt && opt instanceof Error) {
        return message.errorFun(opt.message || "出错了");
    }
    if (opt === "cancel") {
        return false;
    }
    return message.errorFun(opt);
};
